import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../util/axiosBaseQuery";

export interface ApplySubscriptionVoucherRequest {
    commercialModelId: string;
    code: string;
}

export interface ApplySubscriptionVoucherResponse {
    success: boolean;
    message: string;
    data: {
        originalAmount: number;
        newAmount: number;
        voucherId: string;
        discount: number;
    };
}

export interface GetVoucherByCodeAndLocationAndGroupRequest {
    voucherCode: string;
    locationId: string;
    groupId: string;
}

export const vouchersApiSlice = createApi({
    reducerPath: "vouchersApiSlice",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["voucherItem"],
    endpoints: (builder) => ({
        getVoucherByCodeAndLocationAndGroup: builder.query({
            query: (data: GetVoucherByCodeAndLocationAndGroupRequest) => {
                return {
                    url: `/voucher/${data.voucherCode}/location/${data.locationId}/group/${data.groupId}`,
                    method: "GET",
                };
            },
            providesTags: ["voucherItem"],
        }),
        applySubscriptionVoucher: builder.mutation<
            ApplySubscriptionVoucherResponse,
            ApplySubscriptionVoucherRequest
        >({
            query: ({ commercialModelId, code }) => ({
                url: `/commercial-model/${commercialModelId}/voucher`,
                method: "POST",
                data: { code },
            }),
        }),
    }),
});

export const { useGetVoucherByCodeAndLocationAndGroupQuery, useApplySubscriptionVoucherMutation } =
    vouchersApiSlice;
